module.exports = __webpack_public_path__ + "static/media/USLUGA1.7d972e00.jpeg";